import {Fancybox} from "@fancyapps/ui/src/Fancybox/Fancybox.js"

import "@fancyapps/ui/src/Fancybox/Fancybox.scss"

import cs from "@fancyapps/ui/src/Fancybox/l10n/cs"

const fancyboxSettings = {
  l10n: cs,
  Image: {
    zoom: false,
  },
  Toolbar: {
    display: ["close"],
  },
}

Fancybox.bind("[data-fancybox]", fancyboxSettings)
const fancyboxButton = document.querySelectorAll<HTMLElement>("[data-fancybox-open]")
fancyboxButton.forEach((button) => {
  button.addEventListener("click", (e) => {
    e.preventDefault()
    const galleryItem = document.querySelector<HTMLElement>(`[data-fancybox=${button.dataset.fancyboxOpen}]`)
    galleryItem?.click()
  })
})
